/* eslint-disable camelcase */
export enum MonitoringPreferencesTypes {
  GET_MONITORING_PREFERENCES_REQUEST = '@monitoringPreferences/GET_MONITORING_PREFERENCES_REQUEST',
  GET_MONITORING_PREFERENCES_SUCCESS = '@monitoringPreferences/GET_MONITORING_PREFERENCES_SUCCESS',
  GET_MONITORING_PREFERENCES_FAILURE = '@monitoringPreferences/GET_MONITORING_PREFERENCES_FAILURE',
  UPDATE_MONITORING_PREFERENCES_REQUEST = '@monitoringPreferences/UPDATE_MONITORING_PREFERENCES_REQUEST',
  UPDATE_MONITORING_PREFERENCES_SUCCESS = '@monitoringPreferences/UPDATE_MONITORING_PREFERENCES_SUCCESS',
  UPDATE_MONITORING_PREFERENCES_FAILURE = '@monitoringPreferences/UPDATE_MONITORING_PREFERENCES_FAILURE',
  DELETE_MONITORING_PREFERENCES_REQUEST = '@monitoringPreferences/DELETE_MONITORING_PREFERENCES_REQUEST',
  DELETE_MONITORING_PREFERENCES_SUCCESS = '@monitoringPreferences/DELETE_MONITORING_PREFERENCES_SUCCESS',
  DELETE_MONITORING_PREFERENCES_FAILURE = '@monitoringPreferences/DELETE_MONITORING_PREFERENCES_FAILURE',
}

export interface MonitoringPreferenceData {
  id: number;
  client_id: number;
  usuario_id: number;
  message_notification: boolean;
  email_notification: boolean;
  sound_notification: boolean;
  push_notification: boolean;
  receive_notification_from_all_messages: boolean;
  all_messages_priority?: 'alta' | 'media' | 'baixa';
  sounds?: { alta: string; media: string; baixa: string };
}

export interface RequestState {
  get_monitoring_preferences: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  update_monitoring_preferences: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  delete_monitoring_preferences: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export interface MonitoringPreferencesState {
  readonly monitoring_preferences: Array<MonitoringPreferenceData>;
  readonly request: RequestState;
}
